import { Folder } from '@lockton-apps/shared/interfaces';
import { flow, map, reverse } from 'lodash';

const mapFolderToName = (folders: Folder[]) => map(folders, 'folder.name');

export const folderPath = flow(getParentFolders, reverse, mapFolderToName);

function getParentFolders(folders: Folder[], id: number | null): Folder[] {
  let structuredFolders = [] as Folder[];

  const folder = folders.find((folder) => folder.id === id);

  if (folder) {
    structuredFolders = [folder];

    if (folder.parentFolderId) {
      const parentIds = getParentFolders(folders, folder.parentFolderId);
      structuredFolders = [...structuredFolders, ...parentIds];
    }
  }
  return structuredFolders;
}

export function getNestedFolders(
  folders: Folder[],
  rootFolderId: number
): Folder[] {
  const result: Folder[] = [];

  function findChildren(parentId: number) {
    // Find direct children
    const children = folders.filter(
      (folder) => folder.parentFolderId === parentId
    );

    // Add children to result array
    result.push(...children);

    // Recursively find nested children
    children.forEach((child) => findChildren(child.id));
  }

  // Start the recursive search
  findChildren(rootFolderId);

  return result;
}
